export default "__VITE_ASSET__DoYiwwsU__"